import { useState } from 'react';
import { PanelLeft } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { DarkTexture } from './DarkTexture';

export const PortalLayout = ({ sidebar, breadcrumb, children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="relative bg-navy min-h-screen pt-20 overflow-hidden" data-testid="portal-layout">
      <DarkTexture orbs={false} />
      <div className="relative border-b border-white/10 bg-navy/70 backdrop-blur-2xl px-4 sm:px-6 lg:px-10 py-3.5 flex items-center gap-3">
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetTrigger asChild>
            <button data-testid="portal-mobile-sidebar-toggle" className="lg:hidden flex items-center gap-2 text-sm text-white/80 font-medium border border-white/15 rounded-full px-3 py-1.5 hover:border-cyan/50 hover:text-cyan transition-colors">
              <PanelLeft size={14} /> Browse
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="w-80 p-0 overflow-y-auto bg-navy border-white/10">
            <div className="p-5 pt-8" data-testid="portal-sidebar-mobile" onClick={() => setMobileOpen(false)}>{sidebar}</div>
          </SheetContent>
        </Sheet>
        {breadcrumb}
      </div>
      <div className="relative max-w-7xl mx-auto flex gap-8 px-4 sm:px-6 lg:px-10 py-8 lg:py-12">
        <aside className="hidden lg:block w-72 shrink-0" data-testid="portal-sidebar-desktop">
          <div className="sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto pr-2">{sidebar}</div>
        </aside>
        <main className="flex-1 min-w-0" data-testid="portal-main-content">
          <div className="bg-paper rounded-2xl border border-black/5 shadow-[0_24px_60px_-15px_rgba(0,0,0,0.5)] p-6 sm:p-10 lg:p-14">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
